import { render, staticRenderFns } from "./material-manufacturers.vue?vue&type=template&id=1aaf2250&"
import script from "./material-manufacturers.vue?vue&type=script&lang=js&"
export * from "./material-manufacturers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1aaf2250')) {
      api.createRecord('1aaf2250', component.options)
    } else {
      api.reload('1aaf2250', component.options)
    }
    module.hot.accept("./material-manufacturers.vue?vue&type=template&id=1aaf2250&", function () {
      api.rerender('1aaf2250', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Inshape/Admin/Materials/AddMaterial/ManufacturerComponent/material-manufacturers.vue"
export default component.exports